import {DisciplineReferralCourse} from './discipline-referral-course.model';
import {UserService} from './../../shared-components/user/user.service';
import {HttpClient} from '@angular/common/http';
import {System} from './../../shared-components/System';
import {YearService} from './../../shared-components/year/year.service';
import {Injectable} from '@angular/core';
import {DisciplineReferral} from './discipline-referral.model';
import {Observable} from 'rxjs';
import {ReferralNote} from './referral-note.model';
import {School} from '../../shared-components/year/school.model';

@Injectable()
export class DisciplineReferralService {

    // Properties
    viewOnlySchools: School[] = [];
    addEditSchools: School[] = [];
    initialStatusFilter: string;

    // Class Functions
    constructor(
        private yearService: YearService,
        private userService: UserService,
        private http: HttpClient
    ) {
    }

    deleteClassroomDisciplineReferral(referralId: number): Observable<any> {
        // PRE: a referral ID signifying the referral to delete
        // POST: deletes that referral on the server (probably softly)
        const queryString = '?referralId=' + referralId;
        return this.http.get<any>(System.apiURL.Classroom + 'DeleteClassroomDisciplineReferral' + queryString);
    }

    getClassroomDisciplineReferralNotes(disciplineReferral: DisciplineReferral) {
        // PRE: a discipline referral to get notes for
        // POST: obtains the notes for that referral
        const queryString = '?disciplineReferralId=' + disciplineReferral.Id;
        return this.http.get<ReferralNote[]>(System.apiURL.Classroom + 'GetClsssroomDisciplineReferralNotes' + queryString);
    }

    saveClassroomDisciplingReferralNotes(disciplineReferral: DisciplineReferral, referralNote: ReferralNote[]) {
        // PRE: a referral note and discipline referral to save the referral note to
        // POST: saves the referral note to the discipline referral
        const queryString = '?disciplineReferralId=' + disciplineReferral.Id;
        return this.http.post<any>(System.apiURL.Classroom + 'SaveClsssroomDisciplineReferralNotes' + queryString, referralNote);
    }

    getDisciplineReferralCourses(studentId: number): Observable<DisciplineReferralCourse[]> {
        // PRE: a student to get courses for
        // POST: obtains the courses for a student
        const queryString = '?studentId=' + studentId +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&schoolId=' + this.yearService.defaultYear.SchoolID;
        return this.http.get<DisciplineReferralCourse[]>(System.apiURL.Classroom + 'GetClsssroomDisciplineReferralCourses' + queryString);
    }
}
